class OlegantColors extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    requestAnimationFrame(() => {
      const selected = this.querySelector('[aria-pressed="true"]');
      const track = this.querySelector('.og-colors-track');
      if (selected && track) track.scrollLeft = Math.max(0, selected.offsetLeft - track.offsetLeft - track.clientWidth / 2 + selected.clientWidth / 2);
    });
  }
  disconnectedCallback() { this.removeEventListener('click', this.handleClick); }
  handleClick = (event) => {
    const button = event.target.closest('button');
    if (!button) return;
    const track = this.querySelector('.og-colors-track');
    if (button.dataset.direction) {
      track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth * .75, behavior: 'smooth'});
      return;
    }
    const scope = this.closest('dialog, .shopify-section');
    const picker = scope?.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
    const input = picker?.querySelector(`input[data-option-value-id="${button.dataset.colorId}"]`);
    if (input && !input.checked) input.click();
  };
}
if (!customElements.get('olegant-colors')) customElements.define('olegant-colors', OlegantColors);
